import React, { useState, useEffect, Dispatch } from 'react';
import { RightMenu } from './rightMenu';
import { ListTableFilter } from './listTableFilter';
import {
  tableDataValues,
  firstColWidthDetect,
  checkItemValType,
  toggleSelectAll,
  toggleCurrentChkBox,
  assignCheck,
  sortCol,
} from './listTableHelpers';
import { useMediaQuery } from 'react-responsive';
import SortBy04 from '../../images/Icon_Filter.png';
import ActionIcon from '../../images/Icon_Action.png';
import ClearFilters from '../../images/Icon_Clear_Filter.png';

type Props = {
  infoListData?: any;
  firstColWidth?: number;
  firstColWidthSm?: number;
  listUrl: string;
  loadInfoTableList: (listUrl: string, paramsArr?: any) => void;
  dropdrownMenuOptions:
    | ((
        ids: number,
        name: string,
        closeMenu: () => void,
        openCloseState: { open: boolean; id: number | null }
      ) => JSX.Element)
    | null;
  setIsPanelClosed: React.Dispatch<React.SetStateAction<boolean>>;
  isPanelClosed: boolean;
  allowSelectAll: boolean;
  filterTable?: boolean;
  noResultsMessage?: string | null;
  hideSideMenu?: boolean;
  getSelectedOpts?: any;
  rowHighlight?: boolean;
  hideChkboxCol?: boolean;
  children?: any;
  // TODO: Generic type to matchinfoListData type
  rowClassname?: (row: any) => string;
};

export const ListTable: React.FC<Props> = ({
  infoListData,
  firstColWidth,
  firstColWidthSm,
  listUrl,
  loadInfoTableList,
  children,
  dropdrownMenuOptions,
  setIsPanelClosed,
  isPanelClosed,
  allowSelectAll,
  filterTable = true,
  noResultsMessage,
  hideSideMenu,
  getSelectedOpts,
  rowHighlight,
  hideChkboxCol,
  rowClassname = () => '',
}) => {
  const {
    listDataOriginal,
    listData,
    dataColumns,
    dataColumnKeys,
    dataItems,
    allCheckedIds,
    tableToFilter,
  } = tableDataValues(infoListData);
  const firstColWidthDetails = firstColWidthDetect(
    useMediaQuery({ query: '(max-width: 1024px)' }),
    firstColWidth,
    firstColWidthSm
  );
  const [checkboxList, setCheckboxList] = useState<Array<number>>([]);
  const [selectedRowName, setSelectedRowName] = useState<string>('');
  const [openFiltersPopup, setFiltersPopup] = useState<boolean>(false);
  const [openDropdownMenu, setDropdownMenu] = useState<{
    open: boolean;
    id: null | number;
  }>({
    open: false,
    id: null,
  });
  const [sortByCol, setSortByCol] = useState<any>(null);

  function itemOptions(itemId: number) {
    setDropdownMenu((state) => ({
      open: !state.open,
      id: state.open ? null : itemId,
    }));
  }

  function getSelectedIdsFunc(ids_list: any) {
    let optList = [];

    for(let i = 0; i < dataItems.length; i++){
      for(let j = 0; j < ids_list.length; j++){
        if(dataItems[i][getSelectedOpts.id] === ids_list[j]){
          optList.push(dataItems[i]);
        }
      }
    }

    getSelectedOpts.getOpts(optList);    
  }

  useEffect(() => {
    if (infoListData && infoListData.sortBy) {
      const sortByCol = infoListData.sortBy.substr(
        0,
        infoListData.sortBy.indexOf(' ')
      );
      const sortByVal = infoListData.sortBy.substring(
        infoListData.sortBy.lastIndexOf(' ') + 1
      );
      setSortByCol({ sortCol: sortByCol, sortVal: sortByVal });
    }
  }, [infoListData]);

  return (
    <React.Fragment>
      {listData && (
        <React.Fragment>
          <div className={"InfoTable" + (hideChkboxCol ? " HideChkboxCol" : "")}>
            <div className="LeftTable">
              <div className="Head">
                <div className="Cell CheckboxCell">
                  {allowSelectAll && (
                    <div className="Checkbox">
                      <input
                        id="toggleSelectAll"
                        type="checkbox"
                        onChange={(event) =>
                          toggleSelectAll(
                            event, 
                            setCheckboxList, 
                            allCheckedIds,
                            getSelectedIdsFunc,
                            getSelectedOpts                           
                          )
                        }
                      />
                      <label
                        className="CustomInput"
                        htmlFor="toggleSelectAll"
                      />
                    </div>
                  )}
                </div>
                <div
                  className={
                    'Cell SecondCol' + (dataColumns[1].bSortable ? ' Sortable' : '')
                  }
                  style={{
                    minWidth: firstColWidthDetails,
                    maxWidth: firstColWidthDetails,
                  }}
                  key={dataColumnKeys[1]}
                  onClick={() =>
                    sortCol(
                      dataColumnKeys[1],
                      listUrl,
                      loadInfoTableList,
                      infoListData
                    )
                  }
                >
                  <span className="Txt">{dataColumns[1].labelValue}</span>
                  {dataColumns[1].bSortable && (
                    <i
                      className={
                        'SortIcon' +
                        (sortByCol && sortByCol.sortCol === dataColumnKeys[1]
                          ? ' ' + sortByCol.sortVal
                          : '')
                      }
                    ></i>
                  )}
                </div>
              </div>
              <div className="TableBody">
                {dataItems.map((item: any) => {
                  return (
                    <div className={"Row" + (rowHighlight && assignCheck(
                      checkboxList,
                      item[dataColumnKeys[0]]
                    ) === true ? " Highlight" : "") + ` ${rowClassname(item)}`} key={item[dataColumnKeys[0]]}>
                      <div className="Cell CheckboxCell">
                        <div className="Checkbox">
                          <input
                            id={item[dataColumnKeys[0]]}
                            type="checkbox"
                            checked={assignCheck(
                              checkboxList,
                              item[dataColumnKeys[0]]
                            )}
                            onChange={() => {
                              toggleCurrentChkBox(
                                checkboxList,
                                setCheckboxList,
                                setSelectedRowName,
                                item[dataColumnKeys[0]],
                                item[dataColumnKeys[1]],
                                allowSelectAll,
                                getSelectedIdsFunc,
                                getSelectedOpts
                              );
                            }}
                          />
                          <label
                            className="CustomInput"
                            htmlFor={item[dataColumnKeys[0]]}
                          />
                        </div>
                      </div>
                      <div
                        className="Cell SecondCol"
                        style={{
                          minWidth: firstColWidthDetails,
                          maxWidth: firstColWidthDetails,
                        }}
                      >
                        <span className="Txt">{item[dataColumnKeys[1]]}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="MiddleTable">
              <div className="Head">
                {dataColumns.map((column: any, index: number) => {
                  if (index > 1) {
                    return (
                      <div
                        className={
                          'Cell' + (column.bSortable ? ' Sortable' : '')
                        }
                        data-head-column-key={column.columnKey}
                        key={dataColumnKeys[index]}
                        onClick={() =>
                          sortCol(
                            dataColumnKeys[index],
                            listUrl,
                            loadInfoTableList,
                            infoListData
                          )
                        }
                      >
                        <span className="Txt">{column.labelValue}</span>
                        {column.bSortable && (
                          <i
                            className={
                              'SortIcon' +
                              (sortByCol &&
                              sortByCol.sortCol === dataColumnKeys[index]
                                ? ' ' + sortByCol.sortVal
                                : '')
                            }
                          ></i>
                        )}
                      </div>
                    );
                  }
                })}
              </div>
              <div className="TableBody">
                {dataItems.map((item: any, itemIndex: number) => {
                  return (
                    <div className={"Row" + (rowHighlight && assignCheck(
                      checkboxList,
                      item[dataColumnKeys[0]]
                    ) === true ? " Highlight" : "") + ` ${rowClassname(item)}`} key={'item_row_' + itemIndex}>
                      {dataColumnKeys.map((column: any, colIndex: number) => {
                        if (colIndex > 1) {
                          const itemVal = checkItemValType(item, column);
                          return (
                            <div
                              className="Cell"
                              key={'item_info_' + itemIndex + '_' + colIndex}
                              data-body-column-key={column}
                            >
                              <span className="Txt">{itemVal}</span>
                            </div>
                          );
                        }
                      })}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="RightTable">
              <div className="Head">
                {tableToFilter && filterTable ? (
                  <div
                    className="Cell NoSortIcon FilterCell"
                    onClick={() =>
                      listData.filters
                        ? loadInfoTableList(listUrl, [
                            { param: 'bClearFilters', value: 'true' },
                            { param: 'filters', value: '' },
                          ])
                        : setFiltersPopup(true)
                    }
                  >
                    {listData.filters ? (
                      <img
                        src={ClearFilters}
                        alt="ClearFilter"
                        className="FilterIcon"
                      />
                    ) : (
                      <img src={SortBy04} alt="Filter" className="FilterIcon" />
                    )}
                  </div>
                ) : (
                  <div className="Cell NoSortIcon"></div>
                )}
              </div>
              <div className="TableBody">
                {dataItems.map((item: any, index: number) => {
                  return (
                    <div className={"Row" + (rowHighlight && assignCheck(
                      checkboxList,
                      item[dataColumnKeys[0]]
                    ) === true ? " Highlight" : "") + ` ${rowClassname(item)}`} key={'item_options_' + index}>
                      <div
                        className="Cell RowOptionCell"
                        style={!isPanelClosed ? { cursor: 'default' } : {}}
                      >
                        <img
                          src={ActionIcon}
                          alt="Options"
                          className="Icon"
                          onClick={() => itemOptions(item[dataColumnKeys[0]])}
                          style={
                            isPanelClosed && !hideSideMenu
                              ? {
                                  visibility: 'visible',
                                }
                              : { visibility: 'hidden' }
                          }
                        />
                        {dropdrownMenuOptions
                          ? dropdrownMenuOptions(
                              item[dataColumnKeys[0]],
                              item[dataColumnKeys[1]],
                              () => itemOptions(item[dataColumnKeys[0]]),
                              openDropdownMenu
                            )
                          : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <RightMenu
              name={selectedRowName}
              checkboxList={checkboxList}
              setIsPanelClosed={setIsPanelClosed}
            >
              {children}
            </RightMenu>
          </div>

          <ListTableFilter
            listUrl={listUrl}
            loadInfoTableList={loadInfoTableList}
            panelOpen={openFiltersPopup}
            togglePanelOpen={setFiltersPopup}
            listData={listData}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
